import { Location } from 'models/Location.jsx';
import { LadderInformation } from 'components/LadderInformation.jsx';
import { UserChatRooms } from 'components/UserChatRooms.jsx';
import { getOrdinal } from '../functions/getOrdinal.jsx';
import { Flair } from './Flair';
import { MatchSearchNotifications } from 'components/MatchSearchNotifications';
import { PreferredGames } from './PreferredGames';
import { RegionRestrictions } from './RegionRestriction';
import Infraction from './Infraction';
import { HealthDisplay } from 'components/Rpg.jsx';
import { CacheableDataObject } from 'models/CacheableDataObject.jsx';
import { Match } from 'models/Match.jsx';
import { JqueryClassFaker } from 'components/JqueryClassFaker.jsx';
import TierRestriction from 'models/TierRestriction.jsx';

import React from 'react';

import store from 'react/redux/store/store';
import { preferredGamesUpdated } from '../react/redux/actions/matchmaking';
import UserSettings from './UserSettings';
import { DateFormat } from '../components/DateFormat';
import FriendData from 'models/FriendData';

import moment from 'moment';
import UserFriends from './UserFriends';
import { LadderPopup } from '../components/LadderPopup';
import UserNote from './UserNote';
import { UserComponent } from "../react/UserComponent";
import { isMobile } from 'react-device-detect';
import { showToast } from "react/toasts/showToast";
import Subscription from "./Subscription";
import InfractionHolder from "./InfractionHolder";
import { LadderInformationGame } from "components/LadderInformationGame";

class User extends CacheableDataObject {
	beforeConstruct() {
		this.ladder_information = LadderInformation.create({
			player: this
		});
		this.showOnlineNotification = _.throttle(this.showOnlineNotification.bind(this), IS_LOCALHOST ? 50 : 60000);
		this.showOfflineNotification = _.throttle(this.showOfflineNotification.bind(this), IS_LOCALHOST ? 50 : 60000);

		this.chat_rooms = UserChatRooms.create();

		this.region_restrictions = new RegionRestrictions();
		this.preferred_games = new PreferredGames();
		this.connected_fields = {};
		this.ignore_list = {};
		this.friends = UserFriends.create();
		this.friend = FriendData.create();
		this.elements = {
			friendlistElement: null,
			userlistElements: [],
			privateChatElement: null,
			hasRemovals: false
		};
		this.hitPoints = new HealthDisplay(3, 3, this);
		this.location = Location.create();
		this.now_searching = new Map();
		this.now_playing = null;
		this.selected_flair = Flair.retrieve({ isNull: true }, 'undefined');
		this.color_preference = null;
		this.settings = new UserSettings();
		this.tier_restrictions = {};
		this.permissions = {};
		this.reported_match_behavior = InfractionHolder.create({ user: this });

	}

	afterUpdate() {
		if(this.isMe()) {
			if(!this.previous_titles) {
				this.previous_titles = {};
			}
			if(!this.chat_rooms) {

			}
			if(!this._established && this.id) {
				this._established = true;
			}
		}
	}

	beforeUpdate(data) {
		if(data instanceof User) {
			if(data === this) {
				// console.error('Double update attempted but returning false');
				return false;
			}
			// console.log(this);
			// console.log(data);
			// throw new Error('Double update happened with attempt to override a user with id '+data.id + ' to '+ this.id);
		}
	}

	static serUsernameListHolder(list) {
		User.usernameListHolder = list;
	}

	static setUserIdListHolder(list) {
		User.idListHolder = list;
	}

	isMe() {
		return this === myUser || this.id === myUser.id;
	}

	getSearchNotifications() {
		return this.search_notifications = this.search_notifications ? this.search_notifications : new MatchSearchNotifications();
	}

	isIgnored() {
		return !!myUser.ignore_list[this.id];
	}

	showOnlineNotification() {
		this._showUserNotification('is online!');
	}

	showOfflineNotification() {
		this._showUserNotification('is offline!');
	}

	_showUserNotification(content) {
		if(!isMobile) {
			showToast({
				user: this,
				content: <span><UserComponent user={this} />{' '}{content}</span>,
			});
		}
	}

	isFriend() {
		if(this.isMe()) {
			return false;
		}
		return myUser.friends.has(this.id) && !!myUser.friends.get(this.id).is_friend;
	}

	requestingFriendshipTo(otherUser) {
		return this.friends.has(otherUser.id) && this.friends.get(otherUser.id).request_sent;
	}

	wantsToBeFriends(otherUser) {
		return this.friends.has(otherUser.id) && this.friends.get(otherUser.id).waiting_response;
	}

	addFlair(element) {
		// console.trace('wat wat');
		var flairUrl, flairIcons;
		let player = this;
		if(player.selected_flair) {
			let retrieveFlairData = function(element) {
				let flairData = null;
				if(element.data('flairData')) {
					flairData = element.data('flairData');
				} else {
					flairData = {};
					flairData.parent = element.parent();

					let flairyHolder = $('<span>').addClass('flairy_holder');
					let afterFlairy = $('<span>').addClass('front_flairy_holder');
					flairyHolder.insertBefore(element);
					afterFlairy.insertAfter(element);

					flairData.icons = new Map();
					flairData.afterIcons = new Map();
					flairData.flairyHolder = flairyHolder;
					flairData.afterFlairyHolder = afterFlairy;
					element.data('flairData', flairData);
				}
				return flairData;
			};

			element.each(function(i, currentElement) {
				let element = currentElement;
				element = $(element);
				element.addClass('wearing_flair');
				let flairData = retrieveFlairData(element);


				if(!flairData.icons.has(player.selected_flair)) {
					player.selected_flair.createElement().appendTo(flairData.flairyHolder);
					flairData.icons.set(player.selected_flair, true);
				}

				let afterFlair = null;
				if(player.is_top_monthly_donator) {
					afterFlair = Flair.retrieve({
						name: 'dolla',
						safe_url: '/images/smilies/ceo.png',
					}, 'dolla');
				}

				if(afterFlair && !flairData.afterIcons.has(afterFlair)) {
					afterFlair.createElement().appendTo(flairData.afterFlairyHolder);
					flairData.afterIcons.set(afterFlair, true);
				} else {
					// alert('remove after flair?');
				}


			});
		}
	}

	updateUserElements(jqueryElements) {
		jqueryElements.applyUsernameClasses(this)
			.data('username', this.username).data('id', this.id !== null ? this.id : null);
		if(!this.username) {
			return;
		}
		jqueryElements.data('username', this.username);
		jqueryElements.data('usernameLowercase', this.usernameLowercase);
		jqueryElements.each((i, element) => {
			element = $(element);
			if(element.prop('tagName') == 'A') {
				element.attr('href', this.getProfileUrl());
			}
			if(this.display_name) {
				if(!jqueryElements.data('displayNameSplit')) {
					jqueryElements.data('displayNameSplit', true);
					let displayName = $('<span>').addClass('display_name');
					displayName.text(this.display_name);
					displayName.appendTo(element);
					let usernameElement = $('<span>').addClass('gangster_name');
					usernameElement.text(this.getStyledUsername());
					usernameElement.appendTo(element);
				}
				jqueryElements.addClass('has_display_name');

				jqueryElements.data('display_name', this.display_name);
			} else {
				if(jqueryElements.data('displayNameSplit')) {
					jqueryElements.empty();
					jqueryElements.removeClass('has_display_name');
					jqueryElements.data('display_name', null);
					jqueryElements.data('displayNameSplit', false);
				}
				element.text(this.getStyledUsername());
			}
		});

	}

	getDisplayedTotalMatchCount() {
		let matchesPlayedTotal = null;
		if(this.total_matches_played_recently !== undefined) {
			return this.total_matches_played_recently.toLocaleString();
		}
		if(this.total_matches_played_recently === undefined && this.total_matches_played !== undefined) {
			return this.total_matches_played.toLocaleString();
		}
		return matchesPlayedTotal;
	}

	getStyledUsername() {
		return this.username ? this.username.replace(/_/g, ' ') : '';
	}

	get displayedName() {
		return this.display_name ? this.display_name : this.getStyledUsername();
	}

	getDisplayedName() {
		return this.displayedName;
	}

	createUsernameElement() {
		var element = $('<span>');
		this.updateUserElements(element);
		return element;
	}

	getTextShadowStyle(forcedStyle = null) {
		const glowColor = forcedStyle || this.glow_color;
		if(glowColor && (this.is_subscribed || forcedStyle)) {
			return `-1px 1px 8px ${glowColor}, 1px -1px 8px ${glowColor}`;
		}
		return '';
	}

	getProfileUrl() {
		if(this.id) {
			return siteUrl + '/player/' + this.id + (this.username ? '/' + this.username : '/unknown');
		} else if(this.username) {
			return siteUrl + '/player/' + this.username;
		} else {
			return '';
		}
	}

	isOnline() {
		if(this.isMe()) {
			return true;
		}
		if(this.hasOwnProperty('is_online')) {
			return this.is_online;
		} else if(this.hasOwnProperty('is_currently_online')) {
			return this.is_currently_online;
		} else {
			return true; // Just assume it's true since we are missing everything.
		}
	}

	getInfractionsUrl() {
		return this.getProfileUrl() + '/infractions';
	}

	getMatchHistoryUrl() {
		return this.getProfileUrl() + '/match-history';
	}

	isSearching() {
		return this.now_searching.size > 0;
	}

	getStatus() {
		if(this.is_playing) {
			return User.statuses.PLAYING;
		}
		if(this.isOnline()) {
			return User.statuses.ONLINE;
		}
		return User.statuses.OFFLINE;
	}

	isLadderMod() {
		return this.is_ladder_mod || this.is_mod;
	}

	isSiteMod() {
		return this.is_mod || this.is_admin;
	}

	addColorPreferenceClasses(classesMap) {
		let mostImportantColorStatement = null;
		if(this.is_subscribed) {
			classesMap.set('is_subscribed', 'Subscribed to SmashLadder');
		}
		if(this.is_cucumber_mod) {
			mostImportantColorStatement = 'Cucumber For Moderator';
			classesMap.set('is_cucumber_mod', mostImportantColorStatement);
		}
		if(this.is_mod) {
			mostImportantColorStatement = 'Red For Moderator';
			classesMap.set('is_mod', mostImportantColorStatement);
		}
		if(mostImportantColorStatement) {
			switch(this.color_preference) {
				case User.specialColors.MAX_NAME_COLOR_SUBSCRIBER_WHITE:
					classesMap.set('is_subscribed_white', mostImportantColorStatement);
					break;
				case User.specialColors.MAX_NAME_COLOR_SUBSCRIBER_BLACK:
					classesMap.set('is_subscribed_black', mostImportantColorStatement);
					break;
			}
		}
		if(this.is_admin) {
			classesMap.set('is_admin', 'Is THE Anther');
		}

		function keepUsernameClass(classesMap, name) {
			for(let colorClass of User.colorClasses) {
				if(colorClass === name) {
					continue;
				}
				classesMap.delete(colorClass);
			}
		}

		switch(this.color_preference) {
			case User.specialColors.MAX_NAME_COLOR_ORANGE:
				keepUsernameClass(classesMap, null);
				break;
			case User.specialColors.MAX_NAME_COLOR_TOP_PLAYER:
				keepUsernameClass(classesMap, 'is_top_player');
				break;
			case User.specialColors.MAX_NAME_COLOR_SUBSCRIBER:
				keepUsernameClass(classesMap, 'is_subscribed');
				break;
			case User.specialColors.MAX_NAME_COLOR_SUBSCRIBER_WHITE:
				keepUsernameClass(classesMap, 'is_subscribed_white', true);
				break;
			case User.specialColors.MAX_NAME_COLOR_SUBSCRIBER_BLACK:
				keepUsernameClass(classesMap, 'is_subscribed_black');
				break;
			case User.specialColors.MAX_NAME_COLOR_CUCUMBER:
				keepUsernameClass(classesMap, 'is_cucumber_mod');
				break;
			case User.specialColors.MAX_NAME_COLOR_RED_MOD:
				keepUsernameClass(classesMap, 'is_mod');
				break;
			case User.specialColors.MAX_NAME_COLOR_ADMIN:
				keepUsernameClass(classesMap, 'is_admin');
				break;
			default:
				break;
		}
		return classesMap;
	}

	cssUsername(cssClasses) {
		const classes = cssClasses ? cssClasses : new JqueryClassFaker();
		classes.set('username', '');
		if(this.is_ignored) {
			classes.set('is_ignored', '');
		}
		if(this.is_donator) {
			classes.set('is_donator', 'Is a Donator to Smashladder??');
		}
		if(this.is_top_player) {
			classes.set('is_top_player');
			if(this.is_top_player.rank) {
				classes.set('top_player_' + this.is_top_player.rank, '');
				if(this.is_top_player.ladder_name) {
					classes.set('top_player_' + this.is_top_player.rank, 'Is '
						+ getOrdinal(this.is_top_player.rank) + ' in '
						+ this.is_top_player.ladder_name);
				}
			}
		}

		this.addColorPreferenceClasses(classes);

		return classes;
	}

	getOnlineFriendCount() {
		return this.friends.getOnlineFriendCount();
	}

	getPendingFriendCount() {
		return this.friends.getPendingFriendCount();
	}

	set display_name(displayName) {
		if(this._display_name === displayName) {
			return;
		}
		this._display_name = displayName;
		this._updateSearchString();
	}

	get display_name() {
		return this._display_name;
	}

	set id(id) {
		this._id = Number.parseInt(id);
		if(isNumeric(this._id)) {
			if(User.idListHolder) {
				User.idListHolder.set(this._id, this);
			}
		}
	}

	get id() {
		return this._id;
	}

	get username() {
		return this._username;
	}

	set username(username) {
		if(this._username === username) {
			return;
		}
		if(this.usernameLowercase) {
			if(this._id && User.usernameListHolder) {
				User.usernameListHolder.delete(this.usernameLowercase);
			}
		}

		this._username = String(username);

		this.usernameLowercase = this.username.toLowerCase();
		if(this._id && User.usernameListHolder) {
			User.usernameListHolder.set(this.usernameLowercase, this);
		}

		this._updateSearchString();
	}

	_updateSearchString() {
		if(!this._username) {
			return;
		}
		this.usernameSearchString = this.usernameLowercase.replace(/[^A-Z0-9]+/ig, ' ');
		if(this._display_name) {
			this.displayNameSearchString = this._display_name.toLowerCase().replace(/[^A-Z0-9]+/ig, ' ');
		}
	}

	setUsername(username) {
		this.username = username;
	}

	get is_muted() {
		return this._is_muted && this._is_muted.isAfter(moment()) && this._is_muted;
	}

	get is_shadow_muted() {
		return this._is_shadow_muted && this._is_shadow_muted.isAfter(moment()) && this._is_shadow_muted;
	}

	get is_link_restricted() {
		return this._is_link_restricted && this._is_link_restricted.isAfter(moment()) && this._is_link_restricted;
	}

}

User.specialColors = {
	MAX_NAME_COLOR_TOP_PLAYER: 1000,
	MAX_NAME_COLOR_ADMIN: 900,
	MAX_NAME_COLOR_RED_MOD: 870,
	MAX_NAME_COLOR_CUCUMBER: 840,
	MAX_NAME_COLOR_SUBSCRIBER_WHITE: 820,
	MAX_NAME_COLOR_SUBSCRIBER_BLACK: 830,
	MAX_NAME_COLOR_SUBSCRIBER: 810,
	MAX_NAME_COLOR_ORANGE: 50,
};

User.colorClasses = [
	'is_admin',
	'is_mod',
	'is_subscribed',
	'is_subscribed_white',
	'is_subscribed_black',
	'is_cucumber_mod',
	'is_orange',
	'is_top_player',
	'is_chat_mod',
	'is_chat_admin',
];

User.prototype.dataLocationParsers = {
	is_muted: (user, data) => {
		user._is_muted = DateFormat.momentFromLadderTime(data.is_muted);
	},
	is_shadow_muted: (user, data) => {
		user._is_shadow_muted = DateFormat.momentFromLadderTime(data.is_shadow_muted);
	},
	is_link_restricted: (user, data) => {
		user._is_link_restricted = DateFormat.momentFromLadderTime(data.is_link_restricted);
	},
	away_message: (user, data) => {
		const awayMessageData = _.trim(data.away_message);
		if(awayMessageData !== '' && _.isString(data.away_message)) {
			user.away_message = _.trim(data.away_message);
		} else {
			user.away_message = null;
		}
	},
	tier_restrictions: (user, data) => {
		if(data.tier_restrictions.ladder_id) {
			user.tier_restrictions[data.tier_restrictions.ladder_id] = TierRestriction.create(data.tier_restrictions);
		} else {
			_.forEach(data.tier_restrictions, (tierRestriction, ladderId) => {
				user.tier_restrictions[ladderId] = TierRestriction.create(tierRestriction);
			});
			// user.tier_restrictions = data.tier_restrictions;
		}
	},
	glow_color: (user, data) => {
		user.glow_color = data.glow_color;
	},
	color_preference: (user, data) => {
		if(data.color_preference) {
			user.color_preference = Number.parseInt(data.color_preference, 10);
		} else {
			user.color_preference = null;
		}
	},
	now_playing: (user, data) => {
		if(data.now_playing && data.now_playing.id) {
			user.now_playing = Match.create(data.now_playing);
		} else {
			user.now_playing = null;
		}
	},
	now_searching: (user, data) => {
		if(data.now_searching && data.now_searching.length) {
			user.now_searching = new Map();
			for(let nowSearching of data.now_searching) {
				const match = Match.create(nowSearching);
				if(match.id) {
					user.now_searching.set(match.id, match);
				}
			}
		} else {
			user.now_searching = new Map();
		}
	},
	is_a_new_account: (user, data) => {
		if(data.is_a_new_account === null) {
			return;
		}
		user.is_a_new_account = data.is_a_new_account;
	},
	is_ignored: (user, data) => {
		if(data.is_ignored === 1 && myUser.ignore_list && data.id && !user.isMe()) {
			myUser.ignore_list[data.id] = user;
		}
	},
	friend: (user, data) => {
		user.friend.update(data.friend);
	},
	friends: (user, data) => {
		user.friends.setFriends(data.friends);
	},
	ignore_list: (user, data) => {
		user.ignore_list = Users.convertCollectionIntoPlainObjects(data.ignore_list);
	},
	selected_flair: (user, data) => {
		if(!data.selected_flair) {
			user.selected_flair = Flair.retrieve({ isNull: true }, 'undefined');
			return;
		}
		// if(user.id == 2276 && data.selected_flair)
		// {
		//     throw new Error('how did we get a flair');
		// }
		user.selected_flair = Flair.retrieve(data.selected_flair, data.selected_flair.name);
	},
	username: (user, data) => {
		user.setUsername(data.username);
	},
	connected_fields: (user, data) => {
		for(let id in data.connected_fields) {
			if(!data.connected_fields.hasOwnProperty(id)) {
				continue;
			}
			user.connected_fields[id] = data.connected_fields[id];
		}
	},
	location: (user, data) => {
		if(data.location instanceof Location) {
			user.location = data.location;
		} else {
			const location = Location.create(data.location);
			if(location.isKnown()) {
				user.location = location;
			}
		}
	},
	mains: (user, data) => {
		console.trace('?!');
	},
	chat_rooms: (user, data) => {
		user.chat_rooms.updateChatRoomData(data.chat_rooms);
	},
	notes: (user, data) => {
		user.notes = [];
		for(let note of data.notes) {
			user.notes.push(UserNote.create(note));
		}
	},
	latest_subscription: (user, data) => {
		user.latest_subscription = Subscription.create(data.latest_subscription);
		user.latest_subscription.user = user;
	},
	league: (user, data) => {
		console.error('there is no reason for league to be here');
		// user.league = new League(data.league);
	},
	ladder_information: (user, data) => {
		user.ladder_information.extend(data.ladder_information);

		let slippiGameInformation = null;
		user.ladder_information.getLadders().forEach((ladderInformationGame) => {
			ladderInformationGame?.ladder?.connected_field_types.forEach((connectedField) => {
				if(connectedField.id === LadderInformationGame.TYPE_SLIPPI_ID) {
					slippiGameInformation = connectedField.pullFieldFromPlayer(user);
					if(!slippiGameInformation?.primary_value) {
						slippiGameInformation = null;
					}
				}
			});
		});
		user.slippiGameInformation = slippiGameInformation;
	},
	region_restrictions: (user, data) => {
		user.region_restrictions = user.region_restrictions.updateRestrictions(data.region_restrictions);
	},
	preferred_games: (user, data) => {
		if(data.preferred_games instanceof PreferredGames) {
			console.log('Copying preferred games', data.preferred_games, data.preferred_games.size);
			user.preferred_games = data.preferred_games;
		} else {
			user.preferred_games.update(data.preferred_games, user);
		}
		if(user.isMe()) {
			store.dispatch(preferredGamesUpdated(new Map(user.preferred_games.games)));
		}
	},
	show_rank_for_friendlies: (user, data) => {
		user.show_rank_for_friendlies = data.show_rank_for_friendlies;
	},
	most_recent_match: (user, data) => {
		user.most_recent_match = Match.retrieve(data.most_recent_match);
	},
	reported_match_behavior: (user, data) => {
		user.reported_match_behavior = InfractionHolder.create({
			infractions: data.reported_match_behavior,
			user: this
		});
	},
	settings: (user, data) => {
		user.settings = user.settings.update(data.settings);
	}
};
User.usernameListHolder = new Map();
User.statuses = {
	ONLINE: 1,
	OFFLINE: 2,
	IDLE: 3,
	PLAYING: 4,
};
User.possibleUsernameClasses = 'is_subscribed is_cucumber_mod is_mod is_top_player is_admin has_dolla wearing_flair';
$.fn.applyUsernameClasses = function(user) {
	var $this = this;
	return $this.each(function() {
		const element = $(this);
		element.removeClass(User.possibleUsernameClasses);
		let isSubscribed = false;
		for(let [className, title] of user.cssUsername()) {
			element.addClass(className);
			if(title) {
				element.attr('title', title);
			}
			if(className === 'is_subscribed') {
				isSubscribed = true;
				if(user.glow_color) {
					element.css('text-shadow', user.getTextShadowStyle());
				}
			}
		}
		if(!isSubscribed) {
			element.css('text-shadow', '');
		}
	});
};

export { User };